import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { tokens } from '../styles/tokens';
import { STRINGS } from '../data/strings';

@customElement('sarah-recap-ants')
export class SarahRecapAnts extends LitElement {
  static styles = [
    tokens,
    css`
      :host {
        display: block;
        font-family: var(--sarah-font-body);
        color: var(--sarah-text);
      }

      .recap-ants {
        display: flex;
        flex-wrap: wrap;
        gap: 30px;
        align-items: center;
      }
      .recap-ants .texte { flex: 1 1 320px; }
      .recap-ants .texte p {
        text-transform: uppercase;
        color: var(--sarah-rose);
        font-weight: 700;
        font-size: 14px;
        letter-spacing: 0.6px;
        margin: 0 0 14px;
      }
      .recap-ants .texte h2 {
        font-family: var(--sarah-font-display);
        font-weight: 800;
        font-size: 28px;
        line-height: 1.2;
        color: var(--sarah-bleu);
        margin: 0;
      }
      @media (max-width: 767px) {
        .recap-ants .texte h2 { font-size: 22px; }
      }
      .recap-ants .image { flex: 0 0 auto; }
      .recap-ants .image img {
        max-width: 220px;
        height: auto;
        display: block;
      }
      @media (max-width: 767px) {
        .recap-ants { flex-direction: column; align-items: flex-start; }
        .recap-ants .image img { max-width: 100%; }
      }
    `,
  ];

  @property({ type: String, attribute: 'assets-base' }) assetsBase = 'assets';

  render() {
    return html`
      <div class="recap-ants">
        <div class="texte">
          <p>${STRINGS.cerfaSpace}</p>
          <h2>${STRINGS.antsSubtitle}</h2>
        </div>
        <div class="image">
          <img src=${`${this.assetsBase}/ants.jpg`} alt="">
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sarah-recap-ants': SarahRecapAnts;
  }
}
